module.exports = __webpack_public_path__ + "img/shouye_saoyisao@2x.e293f4a3.png";